import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'
import { ADD_MEMBER_TO_SPACE, SELECT_EDIT_SPACE_MEMBER } from '@/store/actionTypes'

import { UPDATE_SPACE_ROLE } from './actionTypes'

export const addUserToSpace = (spaceId: string, user: any): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/users`,
        ADD_MEMBER_TO_SPACE,
        { method: 'POST', body: user },
        { args: { organizationId: ':organizationId', spaceId } }
      )
    )
  }
}

export const updateSpaceRoles = (spaceId: string, userId: string, roleIdArray: unknown[]): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/roles`,
        UPDATE_SPACE_ROLE,
        {
          method: 'POST',
          body: {
            userId,
            roleIdArray
          }
        },
        { args: { organizationId: ':organizationId', spaceId, userId, roleIdArray } }
      )
    )
  }
}

export function selectEditSpaceMember(userId: string): AppThunk {
  return function (dispatch) {
    return dispatch(createAction(SELECT_EDIT_SPACE_MEMBER, { userId }))
  }
}
